var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicketIcon = function SvgTicketIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3AACC8",
    strokeWidth: 2,
    clipPath: "url(#ticket-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 10 8.66 5v10L20 30l-8.66-5V15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.996 20.996a7.065 7.065 0 0 1-9.992 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ticket-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h24v24H8z"
  })))));
};
export { SvgTicketIcon as ReactComponent };
export default __webpack_public_path__ + "ee47680f811ba6efd0ba7ce2b1e75cf0.svg";